import React, { useEffect, useRef, useState } from "react";
import {
  DataGrid as DGrid,
  GridColDef,
  GridValueGetterParams,
} from "@mui/x-data-grid";
import { withSnackbar } from "notistack";
import { IconButton, Tooltip } from "@mui/material";
import {
  Replay as IconReload,
  AddBox as IconAdd,
  Edit as IconEdit,
  Check as IconCheck,
  Close as IconClose,
  PictureAsPdf as IconPdf,
  Article as IconFile,
} from "@mui/icons-material";
import DataGrid, {
  Column,
  Editing,
  Paging,
  Scrolling,
  GroupPanel,
  SearchPanel,
  Grouping,
  Toolbar,
  Item,
  Button,
  Lookup,
} from "devextreme-react/data-grid";
import Guid from "devextreme/core/guid";

import TxtBox from "components/Custom/TxtBox";
import UiDialog from "components/Custom/UiDialog";
import RadioBtn from "components/Custom/RadioBtn";
import Btn from "components/Custom/Btn";
import SwitchBtn from "components/Custom/SwitchBtn";
import AutoComplete from "components/Custom/AutoComplete";
import ConfirmDialog from "components/Custom/ConfirmDialog";
import Loader from "components/Custom/Loader";
import UsersSkeleton from "./UsersSkeleton";
import ChkBox from "components/Custom/ChkBox";

import { MASTER_APIs } from "apihandlers/master";
import { GEO_APIs } from "apihandlers/geography";
import { CUSTOMER_APIs } from "apihandlers/customer";
import { PRODUCT_APIs } from "apihandlers/product";
import { NOTIFY, DEFAULTS, FORMATS } from "common/config";
import { COLORS } from "common/colors";
import {
  CONFIRMS,
  LABELS,
  SUCCESS,
  ERRORS,
  WARNINGS,
  SUB_TITLES,
} from "common/lables";

import { COMMON_JS } from "common/scripts";
import ExcelGrid from "components/Custom/ExcelGrid";
import TxtRow from "components/Custom/TxtRow";
import { DateFunctions } from "common/datefunctions";
import SkeletonBox from "components/Custom/SkeletonBox";

const Scheme = (props: any) => {
  const { setDashMenu } = props;
  const [loading, setLoading] = useState(true);
  const [loadingSubGrid, setLoadingSubGrid] = useState(true);

  const [rows, setRows] = useState<any>(null);
  const [schemeRows, setSchemeRows] = useState<any>([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [customerTypes, setCustomerTypes] = useState<any>([]);
  const [states, setStates] = useState<any>([]);
  const [skuFreeBase, setSkuFreeBase] = useState<any>([]);
  const [manageDialog, setManageDialog] = useState(false);
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [changes, setChanges] = React.useState([]);
  const [editRowKey, setEditRowKey] = React.useState(null);
  const [hasChanges, setHasChanges] = useState(false);
  const [itemsRow, setItemRow] = useState<any>([]);

  const COLUMNS = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      align: "center",
      headerAlign: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "schemeNo",
      name: "Scheme No.",
      width: "20%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "schemeName",
      name: LABELS.SCHEME_NAME,
      width: "30%",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "stateName",
      name: LABELS.STATE,
      width: "20%",
      align: "left",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "fromDate",
      name: LABELS.FROM_DATE,
      width: "10%",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "toDate",
      name: LABELS.TO_DATE,
      width: "10%",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "options",
      name: "Options",
      width: "5%",
      renderCell: (params: any) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onEditRow(params.row)}
            >
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  const itemsColumn = [
    {
      key: "valueMark",
      name: LABELS.VALUE_MARK,
      width: "12%",
      type: "text",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: false,
      searchable: false,
    },
    {
      key: "discountPercentage",
      name: LABELS.DISCOUNT_PERCENTAGE,
      width: "12%",
      type: "number",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: false,
      searchable: false,
    },
    {
      key: "quantityMark",
      name: LABELS.QUANTITY_MARK,
      width: "12%",
      type: "text",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: false,
      searchable: false,
    },
    {
      key: "qtyDiscountPercentage",
      name: LABELS.QTY_DISCOUNT_PERCENTAGE,
      width: "12%",
      type: "text",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: false,
      searchable: false,
    },
    {
      key: "skuFreeBase",
      name: LABELS.SKU_FREE_BASE,
      width: "15%",
      type: "dropdown",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: false,
      searchable: false,
      list: skuFreeBase,
    },
    // {
    //   key: "skuFreeBaseName",
    //   name: LABELS.NAME,
    //   width: "12%",
    //   type: "text",
    //   align: "center",
    //   headerAlign: "center",
    //   editable: true,
    // },
    {
      key: "skuBaseMark",
      name: LABELS.SKU_BASE_MARK,
      width: "12%",
      type: "text",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: false,
      searchable: false,
    },
    {
      key: "skuOffer",
      name: LABELS.SKU_OFFER,
      width: "15%",
      type: "dropdown",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: false,
      searchable: false,
      list: skuFreeBase,
    },
    {
      key: "skuOfferQunatity",
      name: LABELS.SKU_OFFER_QTY,
      width: "12%",
      type: "text",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: false,
      searchable: false,
    },
    {
      key: "skuOfferPercentage",
      name: LABELS.SKU_OFFER_PERCENTAGE,
      width: "12%",
      type: "text",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: false,
      searchable: false,
    },
  ];

  const itemGridRef: any = useRef(null);
  const customerTypesRef: any = useRef();
  const statesRef: any = useRef();

  useEffect(() => {
    if (loading) {
      getStates();
    }
  }, [loading]);

  const getStates = () => {
    const args = {
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
      minResponse: true,
    };
    GEO_APIs.getStates(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.stateName,
          };
        });
        getCustomerTypes(list);
      }
    });
  };

  const getCustomerTypes = (statesList = []) => {
    const args = {
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
      minResponse: true,
    };
    CUSTOMER_APIs.getCustomerTypes(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.name,
          };
        });
        getskuFreeBase(statesList, list);
      }
    });
  };

  const getskuFreeBase = (statesList = [], cTypes = []) => {
    const args = {
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
      minResponse: true,
    };
    PRODUCT_APIs.getProductsSku(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.productName,
          };
        });
        setStates(statesList);
        setCustomerTypes(cTypes);
        setSkuFreeBase(list);
        getRows();
      }
    });
  };

  const getRows = () => {
    const args = {
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
    };

    MASTER_APIs.getSchemeMaster(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records;
        let recJson = {};
        for (let i = 0; i < response.records.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatusText"] = "Yes";
          } else {
            list[i]["activeStatusText"] = "No";
          }
          if (!recJson[list[i]["id"]]) {
            recJson[list[i]["id"]] = [];
          }
          recJson[list[i]["id"]].push(list[i]);
        }
        let tmpList = [];
        for (let id in recJson) {
          let tmpRec = recJson[id][0];
          tmpRec["rows"] = recJson[id];
          tmpList.push(tmpRec);
        }
        setRows(tmpList);
        setFilteredRows([]);
        setLoading(true);
      }
    });
  };

  const getSchemeDetails = async (schemeId) => {
    const args = {
      schemeId,
    };
    console.log("Scheme", args);
    await MASTER_APIs.getSchemeDetails(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        setItemRow(response.records);
        setLoadingSubGrid(true);
      }
    });
  };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
    setItemRow([]);
  };

  const onEditRow = (row) => {
    setSelectedRow(row);
    setManageDialog(true);
    setLoadingSubGrid(false);
    getSchemeDetails(row.id);
  };

  const manageRecord = () => {
    // const schemeNo = (
    //   document.getElementById("schemeNo") as HTMLInputElement
    // ).value.trim();
    // const schemeName = (
    //   document.getElementById("schemeName") as HTMLInputElement
    // ).value.trim();
    const schemeDetail = (
      document.getElementById("schemeDetail") as HTMLInputElement
    ).value.trim();
    const fromDate = (
      document.getElementById("fromDate") as HTMLInputElement
    ).value.trim();
    const toDate = (
      document.getElementById("toDate") as HTMLInputElement
    ).value.trim();
    const monday = (document.getElementById("monday") as HTMLInputElement)
      .checked;
    const tuesday = (document.getElementById("tuesday") as HTMLInputElement)
      .checked;
    const wednesday = (document.getElementById("wednesday") as HTMLInputElement)
      .checked;
    const thursday = (document.getElementById("thursday") as HTMLInputElement)
      .checked;
    const friday = (document.getElementById("friday") as HTMLInputElement)
      .checked;
    const saturday = (document.getElementById("saturday") as HTMLInputElement)
      .checked;
    const sunday = (document.getElementById("sunday") as HTMLInputElement)
      .checked;
    const active = (document.getElementById("active") as HTMLInputElement)
      .checked;
    const customerTypeId = customerTypesRef.current.selectedValue.id;
    const stateId = statesRef.current.selectedValue.id;

    // Validations
    let errors = [];
    if (schemeDetail === "") {
      errors.push({
        id: "schemeDetail",
        msg:
          "<span class='bold'>" +
          LABELS.SCHEME_DETAIL +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (fromDate === "") {
      errors.push({
        id: "fromDate",
        msg:
          "<span class='bold'>" +
          LABELS.FROM_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (toDate === "") {
      errors.push({
        id: "toDate",
        msg:
          "<span class='bold'>" +
          LABELS.TO_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!customerTypeId) {
      errors.push({
        id: "customerTypeId",
        msg:
          "<span class='bold'>" +
          LABELS.CUSTOMER +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!stateId) {
      errors.push({
        id: "stateId",
        msg:
          "<span class='bold'>" +
          LABELS.STATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }

    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }
    const args = {
      schemeId: selectedRow.id || -1,
      // schemeName,
      schemeDetail,
      fromDate,
      toDate,
      isMon: monday.toString(),
      isTue: tuesday.toString(),
      isWed: wednesday.toString(),
      isThu: thursday.toString(),
      isFri: friday.toString(),
      isSat: saturday.toString(),
      isSun: sunday.toString(),
      active: active.toString(),
      stateId,
      customerTypeId,
      items: itemGridRef.getRowData(),
    };
    console.log("manageScheme: ", args, schemeRows);
    MASTER_APIs.manageScheme(args).then((res) => {
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        // setSelectedRow({});
        setManageDialog(false);
        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, res.error);
      }
    });
  };

  const getDeaultItemRow = () => {
    const newRow: any = {
      id: "1." + (itemGridRef.getRowData().length + 1).toString(),
      // valueMark: "",
      // discountPercentage: "",
      // quantityMark: "",
      // qtyDiscountPercentage: "",
      // skuFreeBaseId: "",
      // skuBaseMark: "",
      // skuOfferId: "",
      // skuOfferQunatity: "",
      // skuOfferPercentage: "",
    };
    return newRow;
  };

  const reloadGrid = () => {
    setRows(null);
    setTimeout(() => {
      getRows();
    }, 2000);
  };
  console.log("itemsRow: ", itemsRow);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME} </li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>{LABELS.MASTERS} </li>
          <li className="dim">{" / "}</li>
          <li className="active">{LABELS.SCHEME}</li>
        </ul>
        <h4>{LABELS.SCHEME}</h4>
        <p>{SUB_TITLES.SCHEME}</p>
      </div>
      {/* {rows && (
        <div className="gridOption">
          <TxtBox placeholder={LABELS.SEARCH} onKeyPress={onSearch} />
          <IconButton className="iconBtn" onClick={reloadGrid}>
            <IconReload />
          </IconButton>
          <IconButton
            className="iconBtn"
            onClick={() => {
              setManageDialog(!manageDialog);
              setSelectedRow({});
              let schemas = [];
              for (let i = 0; i < 10; i++) {
                schemas.push({
                  schemeDetailId: "scm-" + i,
                  valueMark: "",
                });
              }
              setSchemeRows(schemas);
            }}
          >
            <IconAdd />
          </IconButton>
        </div>
      )} */}
      {/* <div
        className="grid"
        style={{
          width: "98%",
          height: "80%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      > */}

      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            id={LABELS.SCHEME}
            height={window.innerHeight * 0.8}
            cols={COLUMNS}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={LABELS.SCHEME}
            onReload={reloadGrid}
            onAdd={onAdd}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>

      {/* </div> */}
      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit Scheme: " + selectedRow.schemeDetail
              : "Add New Scheme"
          }
          open={true}
          size={"lg"}
          onClose={() => {
            setManageDialog(false);
            setMandatoryResults([]);
          }}
        >
          {/* <div className="formGroup">
            <label>{"Scheme No."}</label>
            <TxtBox
              id={"schemeNo"}
              placeholder={""}
              defaultValue={selectedRow.name}
            />
          </div> */}
          <div style={{ width: "50%" }}>
            {/* <div className="formGroup">
              <label>{"Scheme Name"}</label>
              <TxtBox
                id={"schemeName"}
                placeholder={""}
                defaultValue={selectedRow.name}
                rows={3}
              />
            </div> */}
            <div className="formGroup required">
              <label>
                {LABELS.SCHEME_DETAIL}
                <span className="red">{" *"}</span>
              </label>
              <TxtBox
                id={"schemeDetail"}
                className={"multiLine"}
                multiline={true}
                placeholder={""}
                defaultValue={selectedRow.schemeDetail}
                rows={3}
              />
            </div>
            <div className="formGroup required">
              <label>{LABELS.CUSTOMER_TYPE}</label>
              <span className="red">{" *"}</span>
              <AutoComplete
                id={"customerTypes"}
                list={customerTypes}
                childRef={customerTypesRef}
                defaultValue={
                  selectedRow.id
                    ? {
                        id: selectedRow.customerTypeId,
                        label: selectedRow.customerTypeName,
                      }
                    : null
                }
                disabled={false}
              />
            </div>
            <div className="formGroup required">
              <label>{"Select State"}</label>
              <span className="red">{" *"}</span>

              <AutoComplete
                id={"states"}
                list={states}
                childRef={statesRef}
                defaultValue={
                  selectedRow.id
                    ? {
                        id: selectedRow.stateId,
                        label: selectedRow.stateName,
                      }
                    : null
                }
                disabled={false}
              />
            </div>
            <div className="formGroup">
              <TxtRow
                id={"fromDate"}
                label={LABELS.FROM_DATE}
                // defaultValue={selectedRow.fromDate}
                defaultValue={
                  selectedRow.id
                    ? DateFunctions.getFormatedDate(
                        selectedRow.fromDate,
                        FORMATS.SQL_DATE_ONLY,
                        FORMATS.SQL_DATE_ONLY
                      )
                    : DateFunctions.getDate(
                        "today",
                        "from",
                        FORMATS.SQL_DATE_ONLY
                      )
                }
                type={"date"}
                required={true}
              />
            </div>
            <div className="formGroup">
              <TxtRow
                id={"toDate"}
                label={LABELS.TO_DATE}
                // defaultValue={selectedRow.toDate}
                defaultValue={
                  selectedRow.id
                    ? DateFunctions.getFormatedDate(
                        selectedRow.toDate,
                        FORMATS.SQL_DATE_ONLY,
                        FORMATS.SQL_DATE_ONLY
                      )
                    : DateFunctions.getDate(
                        "today",
                        "from",
                        FORMATS.SQL_DATE_ONLY
                      )
                }
                type={"date"}
                required={true}
              />
            </div>
            <div className="formGroup">
              <div
                style={{
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  display: "flex",
                  flexWrap: "wrap",
                }}
              >
                <div style={{ marginRight: 10 }}>
                  <ChkBox
                    text={"Monday"}
                    id={"monday"}
                    checked={selectedRow.isMon ? true : false}
                  />
                </div>
                <div style={{ marginRight: 10 }}>
                  <ChkBox
                    text={"Tuesday"}
                    id={"tuesday"}
                    checked={selectedRow.isTue ? true : false}
                  />
                </div>
                <div style={{ marginRight: 10 }}>
                  <ChkBox
                    text={"Wednesday"}
                    id={"wednesday"}
                    checked={selectedRow.isWed ? true : false}
                  />
                </div>
                <div style={{ marginRight: 10 }}>
                  <ChkBox
                    text={"Thursday"}
                    id={"thursday"}
                    checked={selectedRow.isThu ? true : false}
                  />
                </div>
                <div style={{ marginRight: 10 }}>
                  <ChkBox
                    text={"Friday"}
                    id={"friday"}
                    checked={selectedRow.isFri ? true : false}
                  />
                </div>
                <div style={{ marginRight: 10 }}>
                  <ChkBox
                    text={"Saturday"}
                    id={"saturday"}
                    checked={selectedRow.isSat ? true : false}
                  />
                </div>
                <div style={{ marginRight: 10 }}>
                  <ChkBox
                    text={"Sunday"}
                    id={"sunday"}
                    checked={selectedRow.isSun ? true : false}
                  />
                </div>
              </div>
            </div>
            <div className="formGroup">
              <SwitchBtn
                text={LABELS.ACTIVE}
                id={"active"}
                checked={selectedRow.id ? selectedRow.activeStatus : true}
              />
            </div>
          </div>

          {loadingSubGrid ? (
            <div
              className="grid"
              style={{
                width: "98%",
                height: "80%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <ExcelGrid
                id={"items"}
                height={600}
                childRef={itemGridRef}
                cols={itemsColumn}
                rows={itemsRow}
                exportOption={false}
                newRowOption={false}
                needAllRows={true}
                getDefaultNewRow={getDeaultItemRow}
              />
            </div>
          ) : (
            <div>
              <SkeletonBox
                height={40}
                width={"10%"}
                style={{ borderRadius: 5, marginBottom: 5 }}
              />
              <SkeletonBox height={150} width={"98%"} />
            </div>
          )}
          {/* mandatoryResults */}
          {mandatoryResults.length > 0 && (
            <div className="mandatoryBox">
              <ul>
                {mandatoryResults.map((m) => {
                  return (
                    <li>
                      <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}

          <div className="formGroup submitBtnWrapper">
            <div className="flexbtnjustify">
              <Btn
                text={LABELS.CANCEL}
                bgColor={COLORS.RELOAD_EXPORT}
                color={COLORS.RELOAD_EXPORT_TEXT}
                onClick={() => {
                  setManageDialog(false);
                  setMandatoryResults([]);
                }}
                // loading={isSubmit}
              />
              <Btn
                text={LABELS.SAVE}
                onClick={manageRecord}
                // loading={isSubmit}
                bgColor={COLORS.SAVE_GREEN}
              />
            </div>
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(Scheme);
